import { useEffect } from "react";
import { FundSourceCard } from "../../components/elements/CardElements";
import {
  API_WALLET_TRANSFER_CONFIRM,
  API_WALLET_TRANSFER_PREVIEW,
} from "../../constants/apis";
import { COMPONENT, TEXT, TRANSACTIONS } from "../../constants/constants";
import { PropOptions } from "../../utils/formUtils";
import { transactionPinField } from "../../utils/pinUtils";
import useSet from "../common/useSet";
import { showConfetti } from "../../components/elements/ConfettiView";
import { reloadData } from "../../components/lists/ListHandler";
import { useWallet } from "../wallets/useWallet";

export const useTransferForm = ({ form }: any) => {
  const { getWalletBalance } = useWallet();
  let { wallet_number } = form || {};
  const { uploadData, data } = useSet();
  wallet_number = wallet_number?.replaceAll(" ", "");

  useEffect(() => {
    if (wallet_number?.length === 16) {
      uploadData({
        api: API_WALLET_TRANSFER_PREVIEW,
        params: { wallet_number },
      });
    }
  }, [wallet_number]);

  const recipient_name = data?.data?.recipient_name;

  const fields = [
    {
      type: COMPONENT,
      component: (
        <div className="textCenter font12 grey">
          Send money from your wallet to another wallet
        </div>
      ),
    },
    {
      field: "wallet_number",
      type: TEXT,
      required: true,
      props: { inputMode: "numeric" },
    },
    {
      field: "recipient_name",
      type: TEXT,
      required: true,
      value: recipient_name,
      props: PropOptions.disabled,
      visible: recipient_name !== undefined,
    },
    {
      field: "amount",
      type: TEXT,
      required: true,
      props: { prefix: "UGX", ...PropOptions.number },
    },
    transactionPinField,
    {
      type: COMPONENT,
      component: <FundSourceCard />,
    },
  ];

  const onSubmit = ({ payload }: any) => {
    return {
      api: API_WALLET_TRANSFER_CONFIRM,
      params: { ...payload, wallet_number },
      onSuccess: () => {
        reloadData(TRANSACTIONS);
        showConfetti();
        getWalletBalance();
      },
    };
  };
  return { fields, onSubmit, submitText: "Transfer" };
};
